module.exports = __webpack_public_path__ + "fepro/img/opacity-gif.097fb16c.png";